import { Injectable } from '@angular/core';
import { REST_API_REQUEST_CALL_URL } from 'app/utils/rest-api-request-url';
import { Subscription } from 'rxjs';
import { ApiService } from './api.service';

@Injectable()
export class P2PScheduleService {
  
  constructor(
    private apiService:ApiService) {

  }

  // 엑셀 검증
  examineExcelUpload(lineCd: string, data, callback?: (value: any) => void, error?: (error: any) => void, complete?: () => void): Subscription {

    const url = REST_API_REQUEST_CALL_URL.API_INNER;

    return this.apiService.postInnerTargetApi(
      `${url}schedule/p2p/excel/validate/${lineCd}`, data,
      callback, error, complete
    )
  }

  // 엑셀 제출
  submitExcelList(lineCd: string, data, callback?: (value: any) => void, error?: (error: any) => void, complete?: () => void): Subscription {

    const url = REST_API_REQUEST_CALL_URL.API_INNER;

    return this.apiService.postInnerTargetApi(
      `${url}schedule/p2p/excel/upload/${lineCd}`, data,
      callback, error, complete
    )
  }
    
}


// WEBPACK FOOTER //
// ./src/app/services/p2p-schedule.service.ts